import axios from 'axios';

export default {
    get(page) {
        var options = {
            method: 'GET',
            url: window.apiUrl + '/bulletins?page=' + page,
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    getArchived(page) {
        var options = {
            method: 'GET',
            url: window.apiUrl + '/bulletins-archived?page=' + page,
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    getSettings() {
        var options = {
            method: 'GET',
            url: window.apiUrl + '/bulletin-settings',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    changeSettings(eventIds, types, value) {
        var options = {
            method: 'PATCH',
            url: window.apiUrl + '/bulletin-settings',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: { eventIds: eventIds, types: types, value: value }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    markAllAsRead(bulletinIds) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/bulletin-reads',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: { bulletinIds: bulletinIds }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    markAllAsActedOn(bulletinIds) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/bulletin-actedOns',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: { bulletinIds: bulletinIds }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    markAllAsArchived(bulletinIds) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/bulletin-archiveds',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: { bulletinIds: bulletinIds }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    setActedOn(id, actedOn) {
        var options = {
            method: 'PATCH',
            url: window.apiUrl + '/bulletin-actedOn',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: { id: id, actedOn: actedOn }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    setArchived(id, archived) {
        var options = {
            method: 'PATCH',
            url: window.apiUrl + '/bulletin-archived',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: { id: id, archived: archived }
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
    getCategories() {
        var options = {
            method: 'GET',
            url: window.apiUrl + '/bulletin-categories',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
        };
        return axios.request(options).then(function(response) {
            return response.data;
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        })
    },
}



// WEBPACK FOOTER //
// ./src/services/bulletins/index.js